import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar } from '../../../global/commonStyle';

interface Props {
  status?: string;
  isMemberEmpty?: boolean;
}
const Group = styled.div`
  display: flex;
  overflow: hidden;
  ${mobile_xl(css`
    flex-direction: column;
    overflow: unset;
  `)}
`;
const MainDiv = styled.div`
  height: 100vh;
  display: flex;
  flex: auto;
  overflow: hidden;
  .responsive-project-section {
    display: none;
  }
  ${mobile_xl(css`
    flex-direction: column-reverse;
    height: auto;
    gap: var(--space-20);
    padding: var(--space-8) var(--space-20) var(--space-96);
    .responsive-project-section {
      display: flex;
    }
  `)}
`;
const LeftDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  margin: var(--space-0) auto;
  padding: var(--space-24) var(--space-24) var(--space-0) var(--space-24);
  max-width: 1022px;
  ${mobile_xl(css`
    padding: var(--space-0);
  `)}
`;

const LeftContentDiv = styled.div`
  width: 100%;
  ${HideScrollbar}
`;

const LeftHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-16);
  ${mobile_xl(css`
    gap: var(--space-24);
    align-items: center;
  `)}
`;
const Profile = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
  .img {
    cursor: pointer;
    border-radius: var(--border-radius-full);
    border: 0.5px solid var(--border-primary);
    object-fit: cover;
  }
  .empty-img {
    cursor: pointer;
    border-radius: var(--border-radius-full);
    border: 1px solid transparent;
  }
  ${mobile_xl(css`
    gap: var(--space-12);
    .img {
      width: 22px;
      height: 22px;
      border: 0.5px solid var(--border-primary);
    }
    .empty-img {
      width: 24px;
      height: 24px;
    }
  `)}
`;
const ProjectDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  h1 {
    margin: var(--space-0);
    color: var(--text-primary);
    ${Typography.heading_lg}
  }
  p {
    margin: var(--space-0);
    color: var(--text-secondary);
    ${Typography.body_sm}
    border-radius: var(--border-radius-6);
    padding: var(--space-2) var(--space-6);
    border: 1px solid var(--neutral-secondary);
    background: var(--neutral-secondary);
  }
`;

const Project = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  ${mobile_xl(css`
    &.web-project-section {
      display: none;
    }
  `)}
`;
const Title = styled.div`
  width: 100%;
  ${FlexBetween}
  p {
    margin: var(--space-0);
    color: var(--text-primary);
    ${Typography.heading_md}
  }
`;
const ProjectBox = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-gap: var(--space-14);
  grid-template-columns: repeat(auto-fill, minmax(194px, 1fr));
  ${mobile_xl(css`
    display: flex;
    flex-direction: column;
    gap: var(--space-0);
    border: 0.5px solid var(--border-primary);
    border-radius: var(--border-radius-12);
    background-color: var(--background-primary);
  `)}
`;

const ActiveBtn = styled.div`
  color: var(--text-primary);
  ${Typography.body_sm}
  border-radius: var(--border-radius-4);
  background: var(--neutral-secondary);
  padding: var(--space-2) var(--space-5);
  cursor: pointer;
`;

const RightDiv = styled.div`
  width: 100%;
  max-width: 268px;
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  padding: var(--space-24) var(--space-24) var(--space-24) var(--space-16);
  position: relative;
  z-index: var(--z-index-header);
  border-left: 0.5px solid var(--border-primary);
  ${HideScrollbar}
  ${mobile_xl(css`
    padding: var(--space-0);
    border-left: none;
    max-width: 100%;
  `)}
`;

const Link = styled.a`
  text-decoration: none;
  cursor: pointer;
  gap: var(--space-8);
  color: var(--brand-primary);
  ${Typography.body_md_medium}
`;

const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
`;

const ClientDetail = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
`;

const Row = styled.div`
  display: flex;
  padding: var(--space-10) var(--space-12);
  flex-direction: column;
  justify-content: center;
  gap: var(--space-2);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
  p {
    color: var(--text-secondary);
    ${Typography.body_md}
    margin: var(--space-0);
  }
`;
const Row1 = styled.div`
  display: flex;
  padding: var(--space-10) var(--space-12);
  flex-direction: column;
  justify-content: center;
  gap: var(--space-6);
  border-bottom: 0.5px solid var(--border-primary);

  :last-child {
    border-bottom: none;
  }
  ${mobile_xl(css`
    padding: var(--space-7) var(--space-12) var(--space-6);
    gap: var(--space-4);
  `)}
`;
const TextDiv = styled.p`
  color: var(--text-primary);
  ${Typography.body_md_medium};
  margin: var(--space-0);
  text-overflow: ellipsis;
  overflow: hidden;
`;
const EmailTag = styled.p`
  color: var(--brand-primary);
  ${Typography.body_md_medium};
  margin: var(--space-0);
`;
const FirstLine = styled.div`
  ${FlexBetween}
  gap: var(--space-8);
  p {
    margin: var(--space-0);
    color: var(--text-primary);
    ${Typography.body_md_semibold}
  }
  h5 {
    margin: var(--space-0);
    color: var(--text-secondary);
    ${Typography.body_md_medium}
  }
`;
const Tab = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  .active {
    display: flex;
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-4);
  }
  ${mobile_xl(css`
    gap: var(--space-6);
  `)}
`;

const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
`;

const Invoice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-8);
  ${mobile_xl(css`
    width: calc(100vw - 40px);
  `)}
`;
const Table = styled.table<Props>`
  border-collapse: collapse;
  position: relative;
  width: 100%;
  border-spacing: 0;
  .active {
    background-color: var(--background-muted);
    border-radius: var(--border-radius-6);
  }
`;

const TableHead = styled.thead`
  background-color: var(--background-tertiary);
  tr {
    ${FlexBetween}
    gap: var(--space-20);
  }
`;

const TableHeadGroup = styled.div`
  display: flex;
  gap: var(--space-20);
  th {
    &:last-child {
      min-width: 120px;
      height: unset;
      @media (max-width: 1240px) {
        position: relative;
      }
    }
  }
`;

export const TableHeader = styled.th`
  padding: var(--space-10) var(--space-0);
  text-align: left;
  p {
    margin: var(--space-0);
    padding-left: var(--space-20);
    ${Typography.body_md_medium}
    color: var(--text-secondary);
    text-transform: uppercase;
  }
  &:first-child {
    border-top-left-radius: var(--border-radius-8);
    min-width: 112px;
    p {
      padding-left: var(--space-12);
    }
  }

  &:not(:first-child) {
    p {
      box-shadow: var(--left-border);
    }
  }
  &:nth-child(2) {
    min-width: 160px;
  }
  &:nth-child(3) {
    min-width: 160px;
    text-align: right;
  }
  &:nth-child(4) {
    min-width: 86px;
    p {
      padding-left: var(--space-20);
    }
  }
  &:last-child {
    min-width: unset;
    border-top-right-radius: var(--border-radius-8);
    border-left: none;
    min-width: 36px;
    height: 20px;
    @media (max-width: 1240px) {
      position: sticky;
      right: 0;
      background-color: var(--background-tertiary);
      box-shadow: var(--shadow-card);
      min-width: 48px;
    }
    ${mobile_xl(css`
      min-width: 50px;
    `)}
  }
`;

const TableTr = styled.tr<{ isActive: boolean }>`
  ${FlexBetween}
  gap: var(--space-20);
  position: relative;
  cursor: pointer;
  border-top: 0.5px solid var(--border-primary);
  &:hover {
    background-color: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    &:hover {
      background-color: unset;
    }
  `)}
  ${(props) =>
    props.isActive &&
    css`
      background-color: var(--neutral-secondary);
    `}
`;

export const TableDataGroup = styled.div`
  ${AlignCenter}
  gap: var(--space-20);
  td {
    &:last-child {
      all: unset;
      min-width: 120px;
      padding-right: var(--space-0);
      h2 {
        padding-left: var(--space-20);
      }
    }
  }
`;

export const TableData = styled.td`
  padding: var(--space-10) var(--space-0);
  p {
    margin: var(--space-0);
    ${Typography.body_md_medium}
    color: var(--text-secondary);
  }
  &:first-child {
    min-width: 112px;
  }
  &:nth-child(2) {
    min-width: 160px;
  }
  &:nth-child(3) {
    min-width: 160px;
    text-align: end;
  }
  &:last-child {
    padding-right: var(--space-12);
    min-width: max-content;
    @media (max-width: 1240px) {
      position: sticky;
      right: 0;
      padding: var(--space-20) var(--space-12);
      background-color: var(--background-primary);
      ${AlignCenter}
      box-shadow: var(--shadow-card);
    }
    ${mobile_xl(css`
      padding: var(--space-0);
    `)}
    .active {
      background-color: var(--background-muted);
      border-radius: var(--border-radius-4);
    }
  }
`;

const Empty = styled.div<Props>`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  ${FlexCenter}
  flex-direction: column;
  gap: var(--space-20);
  padding: var(--space-36);
  width: -webkit-fill-available;
  ${(props: Props) =>
    props.isMemberEmpty &&
    css`
      padding: var(--space-24) var(--space-14);
      gap: var(--space-16);
      max-width: 240px;
      border-radius: 0;
      border: 0;
      background-color: unset;
      ${mobile_xl(css`
        max-width: unset;
        padding: var(--space-36);
      `)}
    `}
`;

const LeftTitle = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  svg {
    cursor: pointer;
  }
  span {
    ${FlexCenter}
  }
`;

const Overlay = styled.div`
  background-color: var(--background-hover);
  border: 0.5px solid var(--border-primary);
  top: 0;
  left: 0;
  width: 58px;
  height: 58px;
  position: absolute;
  display: none;
  justify-content: center;
  border-radius: var(--border-radius-full);
  cursor: pointer;
  ${mobile_xl(css`
    width: 22px;
    height: 22px;
  `)}
`;
const ProfileImg = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
  display: flex;
  &:hover {
    overflow: hidden;
    border-radius: var(--border-radius-full);
    .img {
      filter: blur(1.5px);
    }
    .edit-profile {
      display: flex;
    }
    .empty-img {
      filter: blur(1.5px);
    }
  }
  ${mobile_xl(css`
    width: 24px;
    height: 24px;
  `)}
`;
const EditIcon = styled.div`
  display: flex;
  justify-content: center;
  margin: auto var(--space-0);
`;

const TableWrapper = styled.div`
  width: 100%;
  margin-bottom: var(--space-24);
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  ${HideScrollbar}

  ${mobile_xl(css`
    width: calc(100vw - 42px);
    margin: var(--space-0) var(--space-0) var(--space-1) var(--space-1);
  `)}
`;

const DropDiv = styled.div`
  height: 100%;
  ${mobile_xl(css`
    padding: var(--space-20) var(--space-12);
  `)}
  .more-icon {
    &:hover {
      background-color: var(--background-muted);
    }
    ${mobile_xl(css`
      &:hover {
        background-color: transparent;
      }
    `)}
  }
`;

export {
  Group,
  MainDiv,
  LeftDiv,
  RightDiv,
  LeftHeader,
  ProjectDetail,
  Profile,
  Project,
  Title,
  ProjectBox,
  ActiveBtn,
  Link,
  RightContent,
  ClientDetail,
  Row,
  FirstLine,
  Tab,
  BottomContent,
  Row1,
  Invoice,
  Table,
  Empty,
  LeftTitle,
  Overlay,
  ProfileImg,
  EditIcon,
  EmailTag,
  TextDiv,
  TableWrapper,
  DropDiv,
  TableTr,
  LeftContentDiv,
  TableHead,
  TableHeadGroup
};
